@use "../../../scss/settings/colors";
.checkbox_container {
  margin-top: 16px;
}

.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Fondo oscuro semi-transparente
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.textfield_animation {
  animation: fadeIn 0.3s ease-in-out;
}

@mixin buttonMixin {
  font-family: 'Regular Inter', sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  min-width: 100px;
  height: 44px;
  border-radius: 8px;
  text-transform: none;
  }

.submission-button {
  @include buttonMixin;
  background-color: colors.$purple-light !important;
  color: colors.$brand-purple !important;
  &:hover{
      color: colors.$base-white !important;
      background-color: colors.$purple-light-2 !important;
      }
    }


.closing-button {
  @include buttonMixin ;
  background-color: colors.$base-white  !important;
  color: colors.$base-black !important;
  text-transform: capitalize !important;
  &:hover{
      background-color: colors.$gray-variant !important;
    }
  }